(function () {
  function blockUnavailableVariantClick(event) {
    var input = event.target.closest('input[data-option-available="false"]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (input.checked) {
      input.checked = false;
    }
  }

  document.addEventListener("click", blockUnavailableVariantClick, true);
  document.addEventListener("change", blockUnavailableVariantClick, true);
})();
